import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';

import { Modal } from '_src/components';
import userPlaceholder from '_src/assets/images/user-placeholder.png';

const ProfileImage = styled.img`
  height: 200px;
  max-width: 100%;
  object-fit: cover;
  margin-top: 10px;
`;

const ProfileButton = styled.button`
  display: block;
  max-width: 100%;
  border-radius: 6px;
`;

const VideoContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export default ({ value, onChange, label }) => {
  const [isCameraShown, setCameraVisibility] = useState(false);
  const videoRef = useRef(null);
  const [videoStream, setVideoStream] = useState();

  const openCamera = async () => {
    setCameraVisibility(true);
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment' }
        });

        if (!videoRef.current) {
          stream.getTracks().forEach(track => track.stop());
          return;
        }

        videoRef.current.srcObject = stream;
        videoRef.current.play();
        setVideoStream(stream);
      } catch {
        setCameraVisibility(false);
        notification.error({ message: 'Camera access is unavailable' });
      }
    } else {
      setCameraVisibility(false);
      notification.error({ message: 'Camera access is unavailable' });
    }
  };

  const takePhoto = () => {
    const video = videoRef.current;

    if (!video || !videoStream) {
      notification.error({ message: 'Camera is not ready' });
      return;
    }

    const canvas = document.createElement('canvas');

    canvas.width = video.width;
    canvas.height = video.height;

    document.querySelector('body').appendChild(canvas);

    canvas.getContext('2d').drawImage(video, 0, 0, video.width, video.height);
    const snapshot = canvas.toDataURL('image/png');
    canvas.parentNode.removeChild(canvas);

    video.pause();
    video.src = '';
    videoStream.getTracks().forEach(track => track.stop());
    setVideoStream(undefined);
    setCameraVisibility(false);
    onChange(snapshot);
  };

  const cleanUp = () => {
    if (videoStream) {
      videoStream.getTracks().forEach(track => track.stop());
    }
    setCameraVisibility(false);
  };

  return (
    <div>
      <div>{label}</div>

      <ProfileButton type="button" onClick={openCamera} aria-label="Change student profile picture">
        <ProfileImage src={value ? value : userPlaceholder} alt="Student profile" />
      </ProfileButton>

      <VideoContainer>
        <Modal
          visible={isCameraShown}
          title="Change student profile picture"
          onCancel={cleanUp}
          okText="Take picture"
          onOk={takePhoto}
          style={{ display: 'flex' }}
        >
          <VideoContainer>
            <video ref={videoRef} width="400" height="300" autoPlay aria-label="Camera preview" />
          </VideoContainer>
        </Modal>
      </VideoContainer>
    </div>
  );
};
